import type { SVGProps } from 'react'

export function Popup(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" {...props}>
      <g id="popup">
        <path
          id="Vector"
          d="M9.99935 14.6668V10.5002M9.99935 10.5002H5.83268M9.99935 10.5002L4.16602 16.3335M12.4992 15.5002H13.9992C14.9326 15.5002 15.3997 15.5002 15.7562 15.3185C16.0698 15.1587 16.3246 14.9039 16.4844 14.5903C16.666 14.2338 16.666 13.7668 16.666 12.8333V6.5C16.666 5.56658 16.666 5.10011 16.4844 4.74359C16.3246 4.42999 16.0698 4.17476 15.7562 4.01497C15.4 3.8335 14.9335 3.8335 14.0019 3.8335H7.66344C6.73185 3.8335 6.26602 3.8335 5.90985 4.01497C5.59625 4.17476 5.34062 4.43023 5.18083 4.74384C4.99935 5.10001 4.99935 5.56599 4.99935 6.49759V8.00016"
          stroke="inherit"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </g>
    </svg>
  )
}
